export enum  WishListMutationTypes {
    SET_ITEM_TO_WISHLIST='SET_ITEM_TO_WISHLIST',
    UNSET_ITEM_FROM_WISHLIST='UNSET_ITEM_FROM_WISHLIST'
}